export default __webpack_public_path__ + "static/media/photo2.15553fd9.jpg";